export const MAX_TIMEOUT_MINUTES = 10 * 60 * 1000;
export const MAX_REQUESTS = 10;
